import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useLocalStorage } from 'vue-composable';
import { ClearMultiselection } from './cardSelection/clearMultiselection';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetActivityIsCollapsed extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetActivityIsCollapsed';

    public constructor(public id: string, public isCollapsed: boolean) {
        super(SetActivityIsCollapsed.ACTION_TYPE);
    }
}

const clearMultiselectionMiddleware = async (state: StorymapState, action: SetActivityIsCollapsed): Promise<boolean> => {
    if (action.isCollapsed) {
        dispatch(new ClearMultiselection());
    }

    return true;
};

const middleware = async (state: StorymapState, action: SetActivityIsCollapsed): Promise<boolean> => {
    const { storage: collapsedActivityIds } = useLocalStorage(`_storiesonboard_${state.id}_collapsedActivityIds`, []);
    if (action.isCollapsed && !collapsedActivityIds.value.includes(action.id)) {
        collapsedActivityIds.value.push(action.id);
    } else if (!action.isCollapsed && collapsedActivityIds.value.includes(action.id)) {
        collapsedActivityIds.value = collapsedActivityIds.value.filter((x) => x !== action.id);
    }

    return true;
};

const reducer = (state: StorymapState, action: SetActivityIsCollapsed): void => {
    const card = state.activities.find(x => x.id == action.id);
    if (card != null) {
        card.isCollapsed = action.isCollapsed;
    }
};

//@ts-ignore
registerMiddleware(SetActivityIsCollapsed.ACTION_TYPE, middleware);

//@ts-ignore
registerMiddleware(SetActivityIsCollapsed.ACTION_TYPE, clearMultiselectionMiddleware);

//@ts-ignore
registerReducer(SetActivityIsCollapsed.ACTION_TYPE, reducer);